// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pipelines[data-v-bd3f81b8]{display:flex}.pipelines .embed-pipelines[data-v-bd3f81b8]{flex:1}", ""]);
// Exports
module.exports = exports;
